/**
 * Powrót do miejsca, z którego ktoś poszedł zakładać konto (FE-06).
 *
 * Bramka albo okno „Załóż darmowe konto” przekazuje adres w `state.from`. Po rejestracji ścieżka biegnie przez
 * mail z linkiem potwierdzającym (często w nowej karcie, czasem następnego dnia), więc `state` routera ginie.
 * Dlatego udana rejestracja zapisuje adres w `localStorage`; potwierdzenie e-maila i logowanie go używają, a udane
 * logowanie zdejmuje. Ważność jak link z maila: 3 dni.
 *
 * Tylko ścieżki wewnątrz serwisu („/…”, bez „//”), żeby zapisany adres nie mógł wyprowadzić na obcą stronę.
 */

const KLUCZ = 'vv:powrot-po-rejestracji'
const WAZNOSC_MS = 3 * 24 * 60 * 60 * 1000

export const sciezkaWewnetrzna = (sciezka) => typeof sciezka === 'string' && sciezka.startsWith('/')
  && !sciezka.startsWith('//') && !sciezka.startsWith('/\\')

export const zapiszPowrot = (sciezka, teraz = Date.now()) => {
  if (!sciezkaWewnetrzna(sciezka)) return
  try {
    window.localStorage.setItem(KLUCZ, JSON.stringify({ sciezka, czas: teraz }))
  } catch {
    // Zablokowana pamięć przeglądarki: po rejestracji wylądujemy na pulpicie, jak dotąd.
  }
}

export const odczytajPowrot = (teraz = Date.now()) => {
  try {
    const zapis = JSON.parse(window.localStorage.getItem(KLUCZ) || 'null')
    if (!zapis || !sciezkaWewnetrzna(zapis.sciezka) || !(teraz - zapis.czas < WAZNOSC_MS)) return null
    return zapis.sciezka
  } catch {
    return null
  }
}

export const wyczyscPowrot = () => {
  try {
    window.localStorage.removeItem(KLUCZ)
  } catch {
    // jak wyżej
  }
}
